__turbopack_context__.v({
  "offsetAnchor": "-W52mq_offsetAnchor",
});
